import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useStore } from './store';
import AppLayout from './components/Layout/AppLayout';
import TaskModal from './components/Tasks/TaskModal';

// Основные страницы — без lazy (они небольшие, быстро загрузятся)
import DashboardPage from './pages/DashboardPage';
import ProjectPage from './pages/ProjectPage';
import WorkloadPage from './pages/WorkloadPage';
import MyTasksPage from './pages/MyTasksPage';

// Auth страницы — lazy (могут быть тяжелее)
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const AuthCallbackPage = lazy(() => import('./pages/AuthCallbackPage'));
const InvitePage = lazy(() => import('./pages/InvitePage'));

function RequireAuth({ children }) {
  const token = useStore(s => s.token);
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const { token, fetchMe, theme } = useStore();

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  useEffect(() => {
    if (token) fetchMe();
  }, [token]);

  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/" element={<RequireAuth><AppLayout /></RequireAuth>}>
            <Route index element={<DashboardPage />} />
            <Route path="workload" element={<WorkloadPage />} />
            <Route path="my-tasks" element={<MyTasksPage />} />
            <Route path="project/:id" element={<ProjectPage />} />
            <Route path="project/:id/:view" element={<ProjectPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
      <TaskModal />
    </BrowserRouter>
  );
}
